import { render, staticRenderFns } from "./TbbCollectAside.vue?vue&type=template&id=2492c769&scoped=true"
import script from "./TbbCollectAside.vue?vue&type=script&lang=js"
export * from "./TbbCollectAside.vue?vue&type=script&lang=js"
import style0 from "./TbbCollectAside.vue?vue&type=style&index=0&id=2492c769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492c769",
  null
  
)

export default component.exports